export const isNullOrUndef = (value) => {
  if (value == null || value == undefined) {
    return true;
  }
  return false;
};
